module.exports = __webpack_public_path__ + "static/img/brees-2020-slide-5.ca9ade2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2020-slide-5.jpg
// module id = 666V
// module chunks = 1